(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('lbx-ipad') || window.__lbxIPadCoreReady) return;
  window.__lbxIPadCoreReady = true;

  function each(list, callback) {
    Array.prototype.forEach.call(list || [], callback);
  }

  function optimizeImages() {
    var main = document.querySelector('main');
    if (!main) return;
    var images = main.querySelectorAll('img');
    each(images, function (image, index) {
      image.decoding = 'async';
      if (index > 2 && !image.hasAttribute('loading')) image.loading = 'lazy';
      if (index > 2 && !image.hasAttribute('fetchpriority')) image.setAttribute('fetchpriority', 'low');
    });
  }

  function optimizeMedia() {
    var videos = document.querySelectorAll('video');
    if (!videos.length) return;

    each(videos, function (video) {
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (video.preload === 'auto') video.preload = 'metadata';
    });

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      each(entries, function (entry) {
        var video = entry.target;
        if (!entry.isIntersecting && !video.paused) video.pause();
        if (entry.isIntersecting && video.hasAttribute('autoplay') && video.paused) {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        }
      });
    }, { rootMargin: '180px 0px', threshold: 0.01 });
    each(videos, function (video) { observer.observe(video); });
  }

  function setViewportHeight() {
    root.style.setProperty('--lbx-ipad-vh', (window.innerHeight * 0.01) + 'px');
  }

  var detachedHeaderVariants = [];

  function detachHeaderNode(node) {
    if (!node || !node.parentNode) return;
    var record = node.__lbxIPadDetachRecord;
    if (!record) {
      record = { node: node, parent: node.parentNode, next: node.nextSibling };
      node.__lbxIPadDetachRecord = record;
      detachedHeaderVariants.push(record);
    }
    if (node.parentNode) node.parentNode.removeChild(node);
  }

  function restoreHeaderVariants() {
    each(detachedHeaderVariants, function (record) {
      if (document.documentElement.contains(record.node) || !record.parent) return;
      if (record.next && record.next.parentNode === record.parent) record.parent.insertBefore(record.node, record.next);
      else record.parent.appendChild(record.node);
    });
  }

  function deferCountryLists() {
    each(document.querySelectorAll('.lb-simple-locale__countries'), function (list) {
      if (list.__lbxIPadDeferred) return;
      list.__lbxIPadDeferred = true;
      var fragment = document.createDocumentFragment();
      var details = list.closest ? list.closest('details') : null;

      function detachCountries() {
        while (list.firstChild) fragment.appendChild(list.firstChild);
      }

      function restoreCountries() {
        if (fragment.firstChild) list.appendChild(fragment);
      }

      if (details) {
        details.addEventListener('toggle', function () {
          if (details.open) restoreCountries();
          else detachCountries();
        });
        if (details.open) restoreCountries();
        else detachCountries();
      } else {
        detachCountries();
      }
    });
  }

  function optimizeHeader() {
    restoreHeaderVariants();
    var desktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;

    if (desktop) {
      each(document.querySelectorAll('.lb-simple-mobile-drawer'), detachHeaderNode);
    } else {
      each(document.querySelectorAll('.lb-simple-header__nav'), detachHeaderNode);
      each(document.querySelectorAll('.lb-simple-header__actions .lb-simple-locale'), detachHeaderNode);
    }

    deferCountryLists();
  }

  function init() {
    root.setAttribute('data-lbx-ipad-optimized', 'true');
    optimizeImages();
    optimizeMedia();
    optimizeHeader();
    setViewportHeight();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var resizeTimer = null;
  window.addEventListener('orientationchange', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      optimizeHeader();
      setViewportHeight();
    }, 180);
  }, { passive: true });
})();
